import {Routes} from '@angular/router';
import {OfferComponent} from './webabo/offer/offer.component';
import {OfferDetailComponent} from './webabo/offer/offer-detail/offer-detail.component';
import {NotFoundComponent} from './core/components/not-found/not-found.component';
import {HupSubscriptionComponent} from './webabo/hup-subscription/hup-subscription.component';
import {MoveComponent} from './webabo/move/move.component';
import {ComplaintComponent} from './webabo/complaint/complaint.component';
import {
  HupSubscriptionDetailComponent
} from './webabo/hup-subscription/hup-subscription-detail/hup-subscription-detail.component';
import {LoginGuard} from './core/components/login/login.guard';
import {BaseDataResolverService} from './core/services/base-data-resolver.service';
import {ParentComponent} from './core/components/parent/parent.component';
import {ContactComponent} from './webabo/contact/contact.component';
import {SubChangeComponent} from './webabo/sub-change/sub-change.component';
import {ComplaintEditComponent} from './webabo/complaint/complaint-edit/complaint-edit.component';
import {SubChangeEditComponent} from './webabo/sub-change/sub-change-edit/sub-change-edit.component';
import {PaymentComponent} from './webabo/payment/payment.component';
import {PaymentEditComponent} from './webabo/payment/payment-edit/payment-edit.component';
import {
  SubscriptionPaymentEditComponent
} from './webabo/payment/subscription-payment-edit/subscription-payment-edit.component';
import {LandingPageComponent} from './webabo/landing-page/landing-page.component';
import {Globals} from './core/globals';
import {LandingPageGuard} from './webabo/landing-page/landing-page.guard';
import {ConfigResolverService} from './core/services/config-resolver.service';
import {ComplaintWihtoutLoginComponent} from './webabo/complaint/complaint-wihtout-login/complaint-wihtout-login.component';
import {OfferOrderedOverviewComponent} from './webabo/offer/offer-ordered-overview/offer-ordered-overview.component';
import {HupSubscriptionTerminateComponent} from './webabo/hup-subscription/hup-subscription-terminate/hup-subscription-terminate.component';
import {RedirectComponent} from './core/components/redirect/redirect.component';
import {LoginFormularComponent} from './core/components/login-formular/login-formular.component';
import {PaymentRedirectComponent} from './core/components/onlinepayment/payment-redirect/payment-redirect.component';
import {ContactWithoutLoginComponent} from './webabo/contact/contact-without-login/contact-without-login.component';
import {OfferGroupComponent} from './webabo/offer-group/offer-group.component';
import {ContactOverviewComponent} from './webabo/contact/contact-overview/contact-overview.component';
import {DelayComponent} from './webabo/delay/delay.component';
import {ComplaintWithoutLoginAfterComponent} from './webabo/complaint/complaint-without-login-after/complaint-without-login-after.component';
import {IdentificationComponent} from "./webabo/identification/identification.component";
import {SubChangeWithoutLoginComponent} from "./webabo/sub-change/sub-change-without-login/sub-change-without-login.component";
import {CustomerComponent} from "./webabo/customer/customer.component";
import {CustomerInvoiceComponent} from "./webabo/customer/customer-invoice/customer-invoice.component";
import {ChildUserGuard} from "./core/components/login/child-user.guard";
import {ChildUserInformationComponent} from "./core/components/child-user-information/child-user-information.component";
import {GuestUserInformationComponent} from "./core/components/guest-user-information/guest-user-information.component";
import {FaqComponent} from "./webabo/faq/faq.component";
import {
  SubChangeWithoutLoginAfterComponent
} from "./webabo/sub-change/sub-change-without-login-after/sub-change-without-login-after.component";
import {OfferPreviewComponent} from "./webabo/offer/offer-preview/offer-preview.component";
import {ExternalLinkGuard} from "./core/guards/external-link.guard";
import {GuestAccountGuard} from "./core/guards/guest-account.guard";
import { EditSubscriptionActionGuard } from "./core/guards/edit-subscription-action-guard";
import {RevocationComponent} from './webabo/revocation/revocation.component';
import {RevocationEditComponent} from './webabo/revocation/revocation-edit/revocation-edit.component';
import {RevocationWithoutLoginComponent} from './webabo/revocation/revocation-without-login/revocation-without-login.component';
import {RevocationWithoutLoginAfterComponent} from './webabo/revocation/revocation-without-login-after/revocation-without-login-after.component';
import {RevocationGuard} from './webabo/revocation/revocation.guard';
import {EditPaymentGuard} from "./core/guards/edit-payment-guard";
import {landingPageResolver} from "./webabo/landing-page/landing-page.resolver";
import {editionResolverService} from "./core/services/edition-resolver.service";
import { terminationGuard } from "./core/guards/termination.guard";
import {AdditionalBookingComponent} from "./webabo/additional-booking/additional-booking.component";
import {AdditionalBookingConfirmComponent} from "./webabo/additional-booking/additional-booking-confirm/additional-booking-confirm.component";
import {AdditionalBookingOrderedComponent} from "./webabo/additional-booking/additional-booking-ordered/additional-booking-ordered.component";
import {AdditionalBookingGuard} from "./webabo/additional-booking/additional-booking.guard";

const defaultRoute = (Globals.USE_LANDING_PAGE) ? 'landing' : 'offer';
// Basiskonfiguration, die das Layout (app.component) app-weit auf jeder Route benötigt.
// Wird beim Bootstrap via provideAppInitializer (siehe app.config.ts) einmal vorgeladen und
// zusätzlich hier pro Route per ConfigResolverService aufgelöst.
export const defaultConfig = ['horizontalNavigation', 'removeNavigation', 'sso.usage', 'sso.client.webabo.id', 'sso.client.webabo.returnUrl', 'sso.server.host'];

export const routes: Routes = [
  {
    path: '',
    redirectTo: defaultRoute,
    resolve: [ConfigResolverService],
    data: {
      config: defaultConfig.concat(['removeOffersIfLoggedIn', 'removeLoginBox', 'removeNavigation']),
      breadcrumb: 'login'
    },
    pathMatch: 'full'
  },
  {
    path: 'landing',
    component: ParentComponent,
    canActivate: [LandingPageGuard, ChildUserGuard],
    resolve: [ConfigResolverService],
    data: {config: defaultConfig.concat(['removeOffersIfLoggedIn', 'removeLoginBox', 'removeNavigation'])},
    children: [
      {path: '', component: LandingPageComponent}
    ]
  },
  {
    path: 'offer',
    component: ParentComponent,
    canActivate: [ChildUserGuard],
    data: {breadcrumb: 'offer_group'},
    children: [
      {
        path: '',
        component: OfferGroupComponent,
      },
      {
        path: 'list/:offerGroup/:moreThanOneGroup',
        component: OfferComponent,
        resolve: [ConfigResolverService],
        data: {
          config: ['offer.highlight.offerId'],
          breadcrumb: 'offer'
        }
      },
      {
        path: ':offerId',
        component: OfferDetailComponent,
        resolve: [BaseDataResolverService, ConfigResolverService, editionResolverService],
        data: {
          baseData: ['countrycodes', 'invoicemethods', 'paymentmethods', 'clienttypes', 'addresscodes', 'titles'],
          config: defaultConfig.concat([
            'paymentprovider.paypal.paymentcode',
            'paymentprovider.buckaroo.paymentcode',
            'order.maxDelayToStart',
            'order.price.combiPricesAsSum',
            'paymentprovider.paypal.clientid',
            'paymentprovider.paypal.isoCurrency',
            'paymentprovider.paypal.disable-funding',
            'requiredFields.addr.phone',
            'offer.askForPhone',
            'requiredFields.addr.birthday',
            'offer.askForBirthday',
            'offer.tracking.upScore.domain',
            'offer.tracking.upScore.version',
            'offer.tracking.upScore.objectIdKey',
            'offer.card.showPriceSegment',
            'client.personWithoutAddressAllowed',
            'subscription.client-without-address.show-warning',
            'askForPaymentAccountHolder',
            'address.addresspart.sequence',
            'subscription.minimal-user-age',
            'offer.maxBonusCount',
            'order.showSEPABox',
            'offer.hideLoginWhileOffer',
            'offer.onlyOneAddress',
            'show.backToOverView.button',
            'offer.showBonusAddress',
            'offer.register.showPassword',
            'offer.askForEditionId',
            'offer.savedQueryParams',
            'offer.privacyDisclaimerAgbInOneField',
            'paymentprovider.paypal.merchantid',
            'paypal.defaultAddressCode',
            'digitalOrder.addressStep.activate',
            'digitalOrder.bonusAddressIsDeliveryAddress',
            'digitalOrder.showDeliveryAddress',
            'digitalOrder.revocationWaiver',
            'summaryStep.offerCard.showSubscriptionDetails'
          ]),
          breadcrumb: 'new_order'
        }
      },
      {
        path: 'ordered/:webId/:backendId/:orderChoiceKey',
        component: OfferOrderedOverviewComponent,
        resolve: [BaseDataResolverService, ConfigResolverService],
        data: {
          baseData: ['products', 'countrycodes', 'invoicemethods', 'paymentmethods', 'clienttypes', 'addresscodes', 'titles'],
          breadcrumb: 'new_order',
          config: defaultConfig.concat([
            "order.timeUntilRedirect",
            "digitalOrder.bonusAddressIsDeliveryAddress",
            "digitalOrder.showDeliveryAddress"
          ])
        }
      },
    ]
  },
  {
    path: 'subscription',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['invoicemethods', 'paymentmethods', 'countrycodes', 'products', 'clienttypes', 'addresscodes', 'terminationtypes'],
      config: defaultConfig.concat([
        'subscription_show_termination_button',
        'showAdditionalSubscriptionInfos',
        'subscription.aggregateSequelAndCombi',
        'subscription.showSequelInAggregateMode',
        'subscription.showStatus',
        'subscription.blockOrder',
        'subscription.showVariantDescription',
        'subscription.showProductDescription',
        'subscription.showOrderNo',
        'show.backToOverView.button',
        'paymentprovider.paypal.merchantid',
        'sourceSystem.PLENIGO.url'
      ]),
      breadcrumb: 'subscription'
    },
    children: [
      {path: '', component: HupSubscriptionComponent},
      {path: ':webId/:backendId', component: HupSubscriptionDetailComponent}
    ]
  },
  {
    path: 'terminate-subscription/:subId',
    canActivate: [LoginGuard, ChildUserGuard, terminationGuard],
    component: ParentComponent,
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['terminationtypes'],
      config: [defaultConfig.concat(['show.backToOverView.button', 'subscription.showTerminationWarning'])]
    },
    children: [
      {path: '', component: HupSubscriptionTerminateComponent}
    ]
  },
  {
    path: 'move',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes', 'products', 'clienttypes', 'addresscodes', 'titles'],
      config: defaultConfig.concat(['move.showContactFormButton', 'address.addresspart.sequence', 'subscription.minimal-user-age']),
      breadcrumb: 'move'
    },
    children: [
      {path: '', component: MoveComponent}
    ]
  },
  {
    path: 'complaint',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes', 'products', 'clienttypes', 'addresscodes', 'complaintgroupcodes', 'complaintactions'],
      config: defaultConfig.concat([
        'complaint.reasongroup.default',
        'complaint.reasongroup.defaultOnline',
        'complaint.webFlags',
        'complaint.imageUpload',
        'complaint.show.digital.orders',
        'show.backToOverView.button',
        'complaint.show.edition',
        'complaint.singleSubscription.showPreview'
      ]),
      breadcrumb: 'complaint'
    },
    children: [
      {path: '', component: ComplaintComponent},
      {
        path: 'new/:subWebId/:subBackendId/:unauthorized/:changeable',
        component: ComplaintEditComponent,
        data: {breadcrumb: 'new_complaint'}
      },
      {
        path: 'edit/:compWebId/:compBackendId/:changeable/:isPrint',
        component: ComplaintEditComponent,
        data: {breadcrumb: 'edit_complaint'}
      },
    ]
  },
  {
    path: 'complaint-without-login',
    component: ParentComponent,
    canActivate: [ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes', 'products', 'clienttypes', 'addresscodes', 'complaintgroupcodes', 'complaintactions'],
      config: defaultConfig.concat([
          'complaint.reasongroup.default',
          'complaint.reasongroup.defaultOnline',
          'complaint.webFlags',
          'client.validation-factors',
          'show.backToOverView.button',
          'complaint.imageUpload',
          'complaint.show.edition',
          'showContactFormOnComplaintViewWithoutLogin',
          'withoutLogin.useIdentificationForm',
          'complaint.deactivate.begin',
          'complaint.deactivate.end',
          'complaint.singleSubscription.showPreview'
      ]),
      breadcrumb: 'complaint'
    },
    children: [
      {path: '', component: ComplaintWihtoutLoginComponent},
      {
        path: 'new/:subBackendId/:clientNo/:unauthorized/:changeable/:isPrint',
        component: ComplaintEditComponent,
        data: {breadcrumb: 'new_complaint'}
      },
      {
        path: 'complaint-without-login-after',
        component: ComplaintWithoutLoginAfterComponent,
        data: {breadcrumb: 'complaint_without_login_after'}
      },
      {
        path: ':clientNo',
        component: ComplaintWihtoutLoginComponent,
        data: {breadcrumb: 'complaint'}
      },
    ]
  },
  {
    path: 'revocation',
    component: ParentComponent,
    canActivate: [RevocationGuard, LoginGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [ConfigResolverService],
    data: {
      config: defaultConfig.concat([
        'revocation.enabled',
        'revocation.button.inOverview'
      ]),
      breadcrumb: 'revocation'
    },
    children: [
      {path: '', component: RevocationComponent},
      {
        path: 'new/:webId/:backendId',
        component: RevocationEditComponent,
        data: {breadcrumb: 'new_revocation'}
      }
    ]
  },
  {
    path: 'revocation-without-login',
    component: ParentComponent,
    canActivate: [RevocationGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [ConfigResolverService],
    data: {
      config: defaultConfig.concat(['revocation.enabled']),
      breadcrumb: 'revocation'
    },
    children: [
      {path: '', component: RevocationWithoutLoginComponent},
      {
        path: 'revocation-without-login-after',
        component: RevocationWithoutLoginAfterComponent,
        data: {breadcrumb: 'revocation_without_login_after'}
      }
    ]
  },
  {
    path: 'delays',
    component: ParentComponent,
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes'],
      breadcrumb: 'delay',
      config: defaultConfig.concat(['address.addresspart.sequence', 'subscription.minimal-user-age'])
    },
    children: [
      {path: '', component: DelayComponent},
      {
        path: '',
        component: DelayComponent,
        data: {breadcrumb: 'delay'}
      },
    ]
  },
  {
    path: 'sub-change',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService, ConfigResolverService, landingPageResolver],
    data: {
      baseData: ['countrycodes', 'products', 'clienttypes', 'addresscodes', 'intermissiontypes', 'titles'],
      config: defaultConfig.concat([
        'subChange.donation.reason',
        'subChange.epaper.reason',
        'subChange.forward.reason',
        'subChange.intermission.reason.default',
        'paymentprovider.paypal.paymentcode',
        'address.addresspart.sequence',
        'subscription.minimal-user-age',
        'subchange.enable.additional.exemplar',
        'show.backToOverView.button',
        'SUBMAXINTERMISSIONDAYS'
      ]),
      breadcrumb: 'subChange'
    },
    children: [
      {path: '', component: SubChangeComponent},
      {
        path: 'new/:subWebId/:subBackendId',
        component: SubChangeEditComponent,
        canActivate: [EditSubscriptionActionGuard],
        data: {breadcrumb: 'new_subChange'}
      },
      {
        path: 'edit/:changeWebId/:changeBackendId/:changeable/:subBackendId',
        component: SubChangeEditComponent,
        data: {breadcrumb: 'edit_sub-change'}
      },
    ]
  },
  {
    path: 'sub-change-without-login',
    canActivate: [ExternalLinkGuard],
    component: ParentComponent,
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes', 'products', 'clienttypes', 'addresscodes', 'intermissiontypes', 'titles'],
      config: defaultConfig.concat([
        'subChange.donation.reason',
        'subChange.epaper.reason',
        'subChange.forward.reason',
        'subChange.intermission.reason.default',
        'paymentprovider.paypal.paymentcode',
        'address.addresspart.sequence',
        'subscription.minimal-user-age',
        'subchange.enable.additional.exemplar',
        'show.backToOverView.button',
        'SUBMAXINTERMISSIONDAYS'
      ]),
      breadcrumb: 'subChange'
    },
    children: [
      {path: '', component: SubChangeWithoutLoginComponent},
      {
        path: 'new/:subBackendId/:clientNo/:unauthorized/:product/:variant',
        component: SubChangeEditComponent,
        data: {breadcrumb: 'new_subChange'}
      },
      {
        path: 'sub-change-without-login-after',
        component: SubChangeWithoutLoginAfterComponent,
        data: {breadcrumb: 'sub-change_without_login_after'}
      },
      {
        path: ':clientNo',
        component: SubChangeWithoutLoginComponent,
        data: {breadcrumb: 'subChange'}
      },
    ]
  },
  {
    path: 'payment',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['products', 'invoicemethods', 'paymentmethods'],
      breadcrumb: 'payment',
      config: defaultConfig.concat([
        'payment.changeOfPaymentConditionsAllowed', 'paymentprovider.paypal.paymentcode'
      ])
    },
    children: [
      {path: '', component: PaymentComponent},
      {
        path: 'payment-edit/:paymentWebId/:paymentBackendId',
        component: PaymentEditComponent,
        canActivate: [EditPaymentGuard]
      },
      {
        path: 'sub-payment-edit/:subWebId/:subBackendId',
        component: SubscriptionPaymentEditComponent,
        canActivate: [EditSubscriptionActionGuard],
        data: {breadcrumb: 'edit_payment'}
      }
    ]
  },
  {
    path: 'contact',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService],
    data: {baseData: ['contactrequesttypes'], breadcrumb: 'contact'},
    children: [
      {path: '', component: ContactComponent}
    ]
  },
  {
    path: 'contact-without-login',
    component: ParentComponent,
    canActivate: [ChildUserGuard, ExternalLinkGuard],
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['contactrequesttypes', 'countrycodes', 'clienttypes', 'addresscodes', 'titles'],
      breadcrumb: 'contact',
      config: defaultConfig.concat(['client.validation-factors', 'address.addresspart.sequence', 'subscription.minimal-user-age'])
    },
    children: [
      {path: '', component: ContactWithoutLoginComponent},
      {
        path: 'new/:subBackendId/:clientNo/:unauthorized/:isPrint',
        component: ContactComponent,
        data: {breadcrumb: 'contact'}
      },
    ]
  },
  {
    path: 'contact-overview',
    component: ParentComponent,
    canActivate: [ChildUserGuard],
    resolve: [ConfigResolverService],
    data: {breadcrumb: 'contact', config: defaultConfig.concat(['show.backToOverView.button'])},
    children: [
      {path: '', component: ContactOverviewComponent}
    ]
  },
  {
    path: 'redirect',
    component: ParentComponent,
    data: {breadcrumb: 'redirect'},
    children: [
      {path: '', component: RedirectComponent}
    ]
  },
  {
    path: 'payment-redirect',
    component: ParentComponent,
    data: {breadcrumb: 'paymentRedirect'},
    children: [
      {path: '', component: PaymentRedirectComponent}
    ]
  },
  {
    path: 'faq',
    component: FaqComponent,
    canActivate: [ExternalLinkGuard],
    data: {breadcrumb: 'faq'}
  },
  {
    path: 'login',
    component: ParentComponent,
    resolve: [ConfigResolverService],
    data: {
      config: defaultConfig,
      breadcrumb: 'login'
    },
    children: [
      {path: '', component: LoginFormularComponent}
    ]
  },
  {
    path: 'identification',
    component: ParentComponent,
    resolve: [BaseDataResolverService, ConfigResolverService],
    data: {
      baseData: ['countrycodes'],
      config: defaultConfig.concat(['identification.matchCount', 'address.addresspart.sequence', 'subscription.minimal-user-age']),
      breadcrumb: 'identification'
    },
    children: [
      {path: '', component: IdentificationComponent},
      {
        path: ':returnPath',
        component: IdentificationComponent,
        data: {breadcrumb: 'identification'}
      },
      {
        // forceRegistration: die Option "ohne Registrierung fortfahren" wird nicht angeboten.
        path: 'register/:returnPath',
        component: IdentificationComponent,
        data: {breadcrumb: 'identification', forceRegistration: true}
      },
    ]
  },
  {
    path: 'additional-booking',
    component: ParentComponent,
    // AdditionalBookingGuard am Elternteil deckt auch die Kindrouten ab
    canActivate: [AdditionalBookingGuard, ChildUserGuard],
    resolve: [ConfigResolverService],
    data: {
      config: defaultConfig.concat([AdditionalBookingConfirmComponent.CAMPAIGN_CONFIG_KEY]),
      breadcrumb: 'additional_booking'
    },
    children: [
      {path: '', component: AdditionalBookingComponent},
      // Die Übersicht bietet Gästen bewusst Login/Identifikation an; die Folgeseiten sind ohne
      // Anmeldung sinnlos und werden daher zusätzlich per LoginGuard geschützt.
      // 'ordered/:orderId' muss VOR ':orderId' stehen - sonst matcht der Parameter das Segment.
      {path: 'ordered/:orderId', component: AdditionalBookingOrderedComponent, canActivate: [LoginGuard]},
      {path: ':orderId', component: AdditionalBookingConfirmComponent, canActivate: [LoginGuard]}
    ]
  },
  {
    path: 'customer',
    component: ParentComponent,
    canActivate: [LoginGuard, ChildUserGuard, GuestAccountGuard],
    data: {breadcrumb: 'customer'},
    children: [
      {path: '', component: CustomerComponent},
      {
        path: 'invoice/:pageSize',
        component: CustomerInvoiceComponent,
        data: {breadcrumb: 'my_invoices'}
      }
    ]
  },
  {
    path: 'preview/offer',
    component: OfferPreviewComponent
  },
  {
    path: 'child-user-info',
    component: ChildUserInformationComponent,
  },
  {
    // defaultConfig ist nötig, weil der Abmelden-Button die sso.*-Konfiguration braucht
    // (LoginService.logout -> getSsoConfiguration wirft sonst)
    path: 'guest-user-info',
    component: GuestUserInformationComponent,
    resolve: [ConfigResolverService],
    data: {config: defaultConfig}
  },
  {path: '**', component: NotFoundComponent}
];
